
import { ref, defineComponent, onMounted, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import Avatar from "vue-avatar-component";
import { Roles } from "@/store/enums/RolesEnums";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
export default defineComponent({
  name: "profile",
  components: {
    Avatar,
  },
  methods: {
    formatCurrency(value) {
      return value.toLocaleString("es-CL", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: "currency",
        currency: "CLP",
      });
    },
  },
  setup() {
    const store = useStore();
    onMounted(() => {
      store
        .dispatch(Actions.GET_FACTURAS_DASHBOARD)
        .then(() => {
          loading.value = false;
        })
        .catch(() => {
          const [error] = Object.keys(store.getters.getErrors);
          Swal.fire({
            text: store.getters.getErrors[error],
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Intentar Nuevamente",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        });
    });
    const loading = ref(true);
    const currentUser = computed(() => {
      return store.getters.currentUser;
    });
    return { currentUser, store, Roles };
  },
});
